import axios from 'axios';
import { CreateNotificationContentRequest } from '../../common/model/dto/notification/create-notification-content-request';
import { ADMIN_NOTIFICATION_CONTENTS_ROUTE } from '../../api/backend';
import { Paginated } from '../../common/types';
import { NotificationContent } from '../../common/model/dto/notification/notification-content';
import { UpdateNotificationContentRequest } from '../../common/model/dto/notification/update-notification-content-request';

export const getNotificationContents = async (
  query: string
): Promise<Paginated<NotificationContent>> => {
  const { data } = await axios.get(
    `${ADMIN_NOTIFICATION_CONTENTS_ROUTE}?${query}`
  );

  return data;
};

export const getNotificationContentById = async (
  id: string
): Promise<NotificationContent> => {
  const { data } = await axios.get(
    `${ADMIN_NOTIFICATION_CONTENTS_ROUTE}/${id}`
  );

  return data;
};

export const createNotificationContent = async (
  createNotificationContentRequest: CreateNotificationContentRequest
) => {
  return await axios.post(
    `${ADMIN_NOTIFICATION_CONTENTS_ROUTE}`,
    createNotificationContentRequest
  );
};

export const updateNotificationContent = async (
  id: string,
  updateNotificationContentRequest: UpdateNotificationContentRequest
) => {
  return await axios.patch(
    `${ADMIN_NOTIFICATION_CONTENTS_ROUTE}/${id}`,
    updateNotificationContentRequest
  );
};

export const deleteNotificationContent = async (
  notificationContentId: string
) => {
  return await axios.delete(
    `${ADMIN_NOTIFICATION_CONTENTS_ROUTE}/${notificationContentId}`
  );
};
